// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"910":"97c35cf55144f87d","2740":"3d21251cfe6c0e76","3484":"8645068a9ea0b2b5","4295":"98cb422943d17179"}[chunkId] + ".js";
};